// @flow strict

import * as React from 'react';
import './Hr.css';
import Header from '../Header/Header';
import HrDisplay from '../../Components/HrDisplay/HrDisplay';

function Hr() {
  return (
    <div>
      <Header></Header>
      <HrDisplay></HrDisplay>
    </div>
  );
}

export default Hr;
